<template>
    <router-view />
</template>
<script>
export default {
    beforeRouteUpdate(to, from, next) {
        if (to.name == 'agro-ocorrencia') {
            next({ name: 'agro-ocorrencia-list' });
        } else if (to.name == 'ven-ocorrencia') {
            next({ name: 'ven-ocorrencia-list' });
        } else {
            next();
        }
    },
    created() {
        if (this.$route.name == 'agro-ocorrencia') {
            this.$router.push({ name: 'agro-ocorrencia-list' });
        } else if (this.$route.name == 'ven-ocorrencia') {
            this.$router.push({ name: 'ven-ocorrencia-list' });
        }
    },
};
</script>
